import { defOpS } from "./compile/emit.js";
import { NEW_OUT, SARGS_V, SET } from "./compile/templates.js";
const [setS, setS2, setS3, setS4] = defOpS(
  SET,
  "o,a",
  SARGS_V,
  "o,a",
  "o",
  NEW_OUT
);
export {
  setS,
  setS2,
  setS3,
  setS4
};
